import * as React from 'react'

const SvgFolderAddIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.25 12.5H15V15h-2.5v1.25H15v2.5h1.25v-2.5h2.5V15h-2.5v-2.5zM17.5 5H10L7.869 2.869A1.25 1.25 0 006.98 2.5H2.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25H10v-1.25H2.5V3.75h4.481L9.12 5.881l.362.369H17.5v4.375h1.25V6.25c0-.69-.56-1.25-1.25-1.25z"
      fill="#163250"
    />
  </svg>
)

export default SvgFolderAddIcon
